import {agencyApi} from 'common/api/entitiesApi'
import {EntitySelector} from 'common/components/reloadable/EntitySelector'
import React from 'react'

export interface Props {
    value?: number
    onChange?: (value?: number | number[]) => void
    style?: React.CSSProperties
    disabled?: boolean
    placeholder?: string
    multiple?: boolean
}

export const AgencySelector = ({value, onChange, style, disabled, placeholder, multiple}: Props) => {

    function findEntity(id: number) {
        return agencyApi.agency(id)
    }

    function searchEntities(search: string, size: number, page: number) {
        return agencyApi.agencyPage('name', 'asc', search, undefined, {query: {size, page}})
    }

    return <EntitySelector
        value={value}
        onChange={onChange}
        loadEntity={findEntity}
        searchEntities={searchEntities}
        placeholder={placeholder}
        disabled={disabled}
        style={style}
        errorText="Can't load Agencies"
        multiple={multiple}
    />
}